@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

.showHide {
    &[aria-hidden="true"] {
        display: none;
    }

    &[aria-hidden="false"] {
        display: block;
    }
}

.container {
    align-items: center;
    background-color: var(--color-black);

    // Pulling in the background image dynamically
    // It's set inline as a CSS Variable
    background-image: var(--background-image);
    background-position-x: var(--background-position);
    background-position-y: bottom;
    background-size: cover;
    display: flex;
    flex-direction: column;
    position: relative;
    justify-content: center;
    width: 100%;
}

.contentWrapper {
    composes: showHide;
    padding: 14vw 0 8vw;
    text-align: center;
}

.withShareIcons {
    padding-bottom: 2vw;
}

.title {
    font-size: 3.75rem;
    line-height: 1;
    margin-bottom: 1rem;
    position: relative;
    text-shadow: 0 0 15px var(--color-black);
    text-transform: uppercase;
    z-index: 10;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        font-size: 1.78rem;
    }
}

.subtitle {
    font-size: 1.875rem;
    line-height: 1;
    position: relative;
    text-shadow: 0 0 15px var(--color-black);
    z-index: 10;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        font-size: 1.125rem;
    }
}

.playButton {
    background-color: transparent;
    border: none;
    cursor: pointer;
    height: 50px;
    padding: 0;
    position: relative;
    width: 50px;
    z-index: 10;

    &::before {
        background-color: var(--color-white);
        content: "";
        display: inline-block;
        height: 50px;
        margin-right: 0.25rem;
        mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 512 512'%3E%3C!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --%3E%3Cpath d='M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c7.6-4.2 16.8-4.1 24.3 .5l144 88c7.1 4.4 11.5 12.1 11.5 20.5s-4.4 16.1-11.5 20.5l-144 88c-7.4 4.5-16.7 4.7-24.3 .5s-12.3-12.2-12.3-20.9V168c0-8.7 4.7-16.7 12.3-20.9z'/%3E%3C/svg%3E");
        mask-position: center;
        mask-repeat: no-repeat;
        mask-size: 50px 50px;
        min-width: 50px;
    }
}

.closeButton {
    composes: showHide;
    cursor: pointer;
    position: relative;
    z-index: 100;
}

.videoFeature {
    composes: showHide;
    max-width: 65vw;
    z-index: 100;
}

.shareContainer {
    color: var(--color-white);
    margin-top: 6vw;
    position: relative;
    text-align: center;
    z-index: 10;

    & a {
        align-items: center;
        display: flex;
    }

    & svg {
        fill: var(--color-white);
        height: 32px;
        width: 32px;
    }
}

.iconContainer {
    align-items: center;
    display: flex;
    gap: 0.5rem;
    justify-content: center;
    margin: 1rem 0;
}

.fineprint {
    font-size: 0.875rem;
}

.textLight {
    composes: textLight from "../CustomBackgroundImageWrapper/index.module.scss";
}

.textDark {
    composes: textDark from "../CustomBackgroundImageWrapper/index.module.scss";
}
